export default {"src":"/_next/static/media/youtube.98f05f33.svg","height":2048,"width":2048};